import { ChangeEvent, useEffect, useState } from "react";
import { useDebounce } from "usehooks-ts";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import useWindowSize from "../../../hooks/useWindowSize";
import {
  getOrderPaymentTypes,
  getOrderStatuses,
  setOrderFilters,
} from "../../../store/actions/orderActions";
import { fetchBrigades } from "../../../store/actions/brigadeActions";
import Search from "../Search";
import OrderTotal from "./components/OrderTotal";
import OrderFilter from "./components/OrderFilter";
import Button from "../../generic/buttons/Button";
import ModalSuccess from "../modals/ModalSuccess/ModalSuccess";
import ModalEditOrder from "../modals/ModalEditOrder";
import OrderList from "./components/OrderList";
import OrderStatusFilter from "./components/OrderStatusFilter/OrderStatusFilter";
import classes from "./Order.module.scss";
import IconButton from "../../generic/buttons/IconButton";
import { getManagers } from "../../../store/actions/managerActions";
import getRole from "../../../utils/getRole";
import ModalExportOrders from "../modals/ModalExportOrders/ModalExportOrders";

function Order() {
  const dispatch = useAppDispatch();
  const windowSize = useWindowSize();
  const [modalCreateShown, modalCreateToggle] = useState(false);
  const [modalCreateSuccessShown, modalCreateSuccessToggle] = useState(false);
  const [modalFilterShown, modalFilterToggle] = useState(false);
  const { creatingFromCall, filters } = useAppSelector((state) => state.order);
  const [modalExportShown, setModalExportShown] = useState(false);
  const { role_id } = useAppSelector((state) => state.auth.user);
  const role = getRole(role_id);

  const [query, setQuery] = useState(filters.query || "");
  const debouncedSearchQuery = useDebounce<string>(query, 500);

  const isAdmin = role?.id == 1;

  const changeSearchHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value);
  };

  useEffect(() => {
    setQuery(filters.query || "");
  }, [filters.query]);

  useEffect(() => {
    dispatch((dispatch, getState) => {
      const currentFilters = getState().order.filters;
      dispatch(setOrderFilters({ ...currentFilters, query: debouncedSearchQuery }));
    });
  }, [debouncedSearchQuery, dispatch]);

  useEffect(() => {
    dispatch(getOrderPaymentTypes());
    dispatch(getOrderStatuses());
    dispatch(getManagers());
    dispatch(fetchBrigades({ page: 1, pageSize: 0 }));
  }, [dispatch]);

  const modalCreate = (modalCreateShown || creatingFromCall) && (
    <ModalEditOrder
      close={() => modalCreateToggle(false)}
      editSuccess={modalCreateSuccessToggle}
    />
  );

  const modalCreateSuccess = modalCreateSuccessShown && (
    <ModalSuccess
      close={() => modalCreateSuccessToggle(false)}
      title={"Заявка создана!"}
    />
  );

  const modalExport = modalExportShown && (
    <ModalExportOrders close={() => setModalExportShown(false)} />
  );

  return (
    <div className={classes.wrap}>
      <div className={classes.total}>
        <OrderTotal />
      </div>
      <div className={classes.top}>
        <div className={classes.search}>
          <Search
            value={query}
            onChange={changeSearchHandler}
            size={"lg"}
            className={classes.search_wrap}
          />
          {windowSize.width < 992 && (
            <IconButton
              icon={"filter"}
              color={"light-blue"}
              size={"lg"}
              onClick={() => modalFilterToggle(true)}
            />
          )}
        </div>
        <div className={classes.filter}>
          <OrderFilter
            showModal={modalFilterShown}
            toggleModal={modalFilterToggle}
          />
          <Button
            color={"red"}
            size={"lg"}
            className={classes.button_create}
            onClick={() => modalCreateToggle(true)}
          >
            Создать заявку
          </Button>
        </div>
      </div>
      {isAdmin && (
        <div className={classes.exportButtonWrp}>
          <Button
            color="primary"
            size="lg"
            onClick={() => setModalExportShown(true)}
            className={classes.exportButton}
          >
            Выгрузить заявки
          </Button>
        </div>
      )}

      <div className={classes.container}>
        <OrderStatusFilter className={classes.status_filter} />
        <OrderList
          className={classes.list}
          searchQuery={debouncedSearchQuery}
        />
      </div>
      {modalCreate}
      {modalCreateSuccess}
      {modalExport}
    </div>
  );
}

export default Order;